<app-base-pesquisa #modal titulo="Pesquisa de Paciente" subtitulo="Para pesquisar um paciente digite o CPF ou uma parte do nome da pessoa (com no mínimo três caractéres). Após a pesquisa, clique duas vezes em cima da linha do registro do paciente para realizar a seleção." 
    (registroSelecionado)="pacienteSelecionado($event)">
    <ng-template appFiltroPesquisa>
        <form novalidate="true" [formGroup]="modelo">
            <div class='form-group' >
                <ejs-textbox [floatLabelType]="'Always'" appItemFocadoFiltroPesquisa formControlName="nomeCpf" [placeholder]="'Paciente (nome/CPF)'"></ejs-textbox>
            </div>

        <div class="form-group">
            <input type="button" ejs-button iconCss="fas fa-search" value="Pesquisar" cssClass="e-primary btn-block"/>
        </div>
        </form>
    </ng-template>
    <ng-template appConteudoPesquisa>
        <ejs-grid #grid appGridPesquisa
            [dataSource]="registros"
            [enableVirtualization]='false' 
            [pageSettings]='{ pageSize: 100 }'
            height='100%' 
            
            [selectionSettings]="{enableToggle: false}"
            [allowFiltering]='false' 
            [allowSorting]='true' 
            [allowResizing]='true' 

            [showColumnChooser]='false'
            [showColumnMenu]='false'
           
            [allowExcelExport]='true'
            [allowPdfExport]='true'
            [allowPdfExport]='true'>
            <e-columns>
                <e-column field='id' [headerText]="'Id'" [visible]="false" [isPrimaryKey]="true"></e-column>
                <e-column field='nome' [headerText]="'Paciente'"></e-column>
                <e-column field='cpf' [headerText]="'CPF'"></e-column>
                <e-column field='pis' [headerText]="'PIS'"></e-column>
                <e-column field='rg' [headerText]="'RG'"></e-column>
                <e-column field='idade' [headerText]="'Idade'"></e-column>
                <e-column field='dataNascimento' [headerText]="'Data Nascimento'" [type]="'date'" [format]="{type: 'date', format: 'dd/MM/yyyy'}"></e-column>
                <e-column field='sexo' [headerText]="'Sexo'"></e-column>              
            </e-columns>

            <e-aggregates>
                <e-aggregate>
                    <e-columns>
                        <e-column field="id" type="count">
                            <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                        </e-column>
                    </e-columns>
                </e-aggregate>
            </e-aggregates>

        </ejs-grid>
    </ng-template>
</app-base-pesquisa>
